import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

interface PostVideoStatementViewMutationParams {
  clientId: string;
  videoName: string;
}

const postVideoStatementViewMutation = ({
  videoName,
  clientId,
}: PostVideoStatementViewMutationParams) =>
  authFetch('/Consumer/DocumentVault/PostVideoStatementView', {
    method: 'POST',
    ...httpBodyOptions({ clientId, videoName }),
  });

export const usePostVideoStatementViewMutation = () => useMutation(postVideoStatementViewMutation);
